import { withTranslations } from '@/utils/Language';

export default withTranslations((lang) =>
  Promise.all([
    import(`@/assets/i18n/familyResourceFinder/${lang}.json`),
    import(`@/assets/i18n/properties/${lang}.json`),
    import(`@/assets/i18n/tags/${lang}.json`),
    import(`@/assets/i18n/ui/${lang}.json`),
    import('@/assets/i18n/languages/default.json'),
    import(`@/assets/i18n/languages_translated/${lang}.json`)
  ]).then(([frf, properties, tags, ui, languages, languagesTranslated]) => ({
    ...frf.default,
    ...properties.default,
    ...tags.default,
    ...ui.default,
    ...languages.default,
    ...languagesTranslated.default
  }))
);
